import * as jsPDF from 'jspdf';
import { renderDate } from 'common/services/util';

export const printDocDevice = ({ dataList }) => {
    let doc = new jsPDF('l', 'mm', [420, 290]);

    dataList.forEach((data, index) => {
        fillDataDevice(doc, data)

        if (index < dataList.length - 1) {
            doc.addPage()
        }
    })

    doc.autoPrint();
    const blob = doc.output('blob');
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 100);
}

const fillDataDevice = (doc, data) => {
    const width = doc.internal.pageSize.getWidth();
    const height = doc.internal.pageSize.getHeight();

    const widthText = width * 0.07
    const dataWithoutNull = checkNullObject(data)
    let { description, reference, unlockCode, dateEntry, clientName, deviceName } = dataWithoutNull;

    doc.setFontSize(55);
    doc.setFontStyle('bold')
    addText(doc, reference, widthText, height * 0.19);

    doc.setFontStyle('normal')
    doc.setFontSize(35);
    addText(doc, renderDate(dateEntry), width * 0.5, height * 0.19);
    //doc.line(widthText, height*0.31, width*0.98, height*0.31);

    doc.setFontSize(34);
    addText(doc, clientName, widthText, height * 0.35);
    //doc.line(widthText, height*0.45, width*0.98, height*0.45);

    doc.setFontSize(40);
    addText(doc, deviceName, widthText, height * 0.5);
    addText(doc, unlockCode, widthText, height * 0.665);
    //doc.line(widthText, height*0.68, width*0.98, height*0.68);

    doc.setFontSize(27);
    addText(doc, description, widthText, height * 0.8, { maxWidth: width - 30 });
}

const addText = (doc, text = "", width, height, options = {}) => {
    doc.text(text, width, height, options)
}

const checkNullObject = object => {
    const newData = {}
    Object.keys(object).forEach(key => {
        newData[key] = object[key] || ''
    })

    return newData
}